export default {
  sign_in_title: "Sign in to your account",
  sign_up_title: "Create a new account",
  email: "Email Address",
  email_required: "Please enter your email address",
  email_placeholder: "your{0}example.com",
  email_invalid: "Please enter a valid email address",
  password: "Password",
  password_placeholder: "Enter your password",
  password_required: "Please enter your password",
  password_invalid:
    "Password must be at least 8 characters and contain letters, numbers, and special characters",
  forgot_password: "Forgot Password?",
  confirm_password_required: "Please confirm your password",
  confirm_password_placeholder: "Confirm password",
  passwords_do_not_match: "The two passwords you entered do not match",
  or: "Or",
  no_account: "Don't have an account?",
  have_account: "Already have an account?",
  error: "Login failed. Please check your email and password.",
  google_error: "Google login failed",
  x_error: "X login failed",
  linkedin_error: "LinkedIn login failed",
  google_sign_in: "Sign in with Google",
  google_sign_up: "Sign up with Google",
  apple_sign_in: "Sign in with Apple",
  apple_sign_up: "Sign up with Apple",
  twitter_sign_in: "Sign in with X",
  twitter_sign_up: "Sign up with X",
  linkedin_sign_in: "Sign in with LinkedIn",
  linkedin_sign_up: "Sign up with LinkedIn",
  aria_card: "Login card",
  aria_email: "Email input field",
  aria_password: "Password input field",
  aria_submit: "Submit button",
  aria_google: "Sign in with Google button",
  aria_linkedin: "Sign in with LinkedIn button",
  aria_switch_mode: "Toggle Sign In/Sign Up Mode",
  welcome: "Welcome to TaxEcoBit",
  subtitle: "EU CBAM Compliant Carbon Tax Calculation Platform",
  benefit1: "Accurate carbon tax calculation with less than 10% error",
  benefit2: "Supports multiple transportation methods and custom factors",
  benefit3: "API integration support",
  benefit4: "Generates compliant reports meeting EU CBAM requirements",
  user_friendly: "User Friendly",
  secure_reliable: "Secure & Reliable",
  cloud_sync: "Cloud Sync",
  invite_code: "Invite Code",
  invite_code_placeholder: "Please enter invite code (optional)",
  invite_code_detected: "Invite code detected",
  invited_by_user: "Invited by",
  sign_out: "Sign Out",
  agreement_prefix: "By registering for TaxEcoBit, you agree to our",
  terms: "Terms of Service",
  and: "and",
  privacy: "Privacy Policy",
  agreement_required: "Please agree to the privacy policy first",
  complete_verification: "Please complete verification first",
  loading_verification: "Loading verification...",
  verification_failed: "Verification failed, please try again",
};
